import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';

const SvgIcon = createSvgIcon(<path transform='translate(-3 -6)' d='M10 19h12v2H6v-2z' />, 'Minimize');

const MinimizeIcon = function (props) {
  return <SvgIcon {...props} />;
};

export default memo(MinimizeIcon);
